function getUrlExtension(url: string): string {
    return url?.split(/[#?]/)[0].split('.').pop()?.trim() ?? '';
}

export default getUrlExtension;
